<template>
  <div class="user-info-selector">
    <img class="avatar" src="../assets/svg/user-pen-alt-svgrepo-com.svg" alt="User Avatar" />
    <div class="dropdown">
      <div class="display-name-container" @click="toggleDropdown">
        <span class="display-name">{{ formatDisplayName(displayName) }}</span>
        <img :class="{ rotated: dropdownOpen }" src="../assets/svg/dropdown-arrow-svgrepo-com.svg"
          class="dropdown-arrow" />
      </div>
      <ul v-if="dropdownOpen" class="dropdown-menu">
        <li @click="openAccountManagement">
          Manage Account
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="js">
import { api_config } from "@/env.ts";
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'UserInfoSelector',
  props: {
    profile: {
      type: Object, required: true
    }
  },
  data() {
    return {
      displayName: null,
      dropdownOpen: false,
      accountUrl: `${api_config.keycloak_url}realms/${api_config.keycloak_realm}/account`,
    };
  },
  mounted() {
    this.displayName = this.getDisplayName();
  },
  methods: {
    getDisplayName(profile) {
      if (!profile?.username) return '';
      const username = profile.username;
      return username;

      // const firstName = profile.value.firstName || profile.value.given_name;
      // const lastName = profile.value.lastName || profile.value.family_name;
      // return firstName || lastName
      //   ? `${firstName || ''} ${lastName || ''}`.trim()
      //   : profile.value.username || profile.value.preferred_username || '';
    },

    formatDisplayName(email) {
      if (!email) { return email; }
      const localPart = email.split('@')[0];
      // split on dots, capitalize each piece, then join with spaces
      return localPart
        .split('.')
        .map(name =>
          name.charAt(0).toUpperCase() +
          name.slice(1).toLowerCase()
        )
        .join(' ');
    },
    async toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen
    },
    openAccountManagement() {
      window.open(this.accountUrl, '_blank', 'noopener');
    },
    openMyReports() {
      this.$emit('open-my-reports', this.profile);
    }
  },
  watch: {
    profile() {
      console.log('new profile:', this.profile);
      this.displayName = this.getDisplayName(this.profile);
    }
  }
})
</script>

<style scoped>
.user-info-selector {
  display: flex;
  align-items: center;
}

.avatar {
  width: 30px;
  height: 30px;
  object-fit: cover;
}

.display-name-container {
  display: flex;
  align-items: center;
  /* Vertically centers the children */
  cursor: pointer;
  /* Optional: indicates the container is clickable */
}

.display-name {
  text-decoration: underline;
  padding-right: 0.2rem;      /* Add small padding so the text is spaced from the dropdown arrow */
}

.dropdown-arrow {
  height: 1.875rem;
}

.dropdown {
  position: relative;
  cursor: pointer;
}

.dropdown-menu {
  position: absolute;
  top: 150%; /* Position the dropdown along the gold spacer bar */
  right: 0;
  left: auto;
  background: var(--colour-surface);
  border: 1px solid var(--colour-border);
  list-style: none;
  padding: 0.5rem 0;
  margin: 0;
  width: max-content;
  white-space: nowrap;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  z-index: 10;
}

.dropdown-menu li {
  padding: 0.5rem 1rem;
  text-align: left;
  padding: 0.5rem
}

.dropdown-menu li a {
  text-decoration: none;
  color: inherit;
}

.dropdown-menu li:hover {
  background-color: var(--colour-bg-subtle);
}

.rotated {
  transform: rotate(180deg);
}
</style>
